export enum IOStatus {
    Open = '1',
    Closed = '0',
    Configured = '3',
    NotConfigured = '2',
}
